import React, { useEffect, useState } from 'react';
import {
  Image, TextInput, TouchableOpacity, View,
} from 'react-native';
import { img_close_x } from '../../../utils/ImagesManagementUtils';

//= ========================================================================

const EditTextElement = ({
  editTextId,
  editTextValue,
  editTextDefValue,
  onTextChanged,
  notEditable,
}) => {
  const [editText, setEditText] = useState(editTextValue);
  const isDefault = editText === '' || editText === editTextDefValue;
  const myStyles = {
    container: {
      marginBottom: 5,
      flexDirection: 'row',
      border: 'solid 1px #a0aec0',
      backgroundColor: notEditable ? '#f7fafc' : null,
      borderRadius: 4,
    },
    textInput: {
      borderRadius: 4,
      padding: 4,
      color: isDefault ? '#a0aec0' : '#001a2f',
      flexBasis: '100%',
    },
    exitButton: {
      width: 24,
      height: 24,
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
  useEffect(() => {
    setEditText(editTextValue);
  }, [editTextId, editTextValue]);
  const onResetPressed = () => {
    setEditText('');
    onTextChanged(editTextId, editTextDefValue);
  };

  const onEnterPressed = () => {
    if (editText === '') {
      onResetPressed();
    } else {
      onTextChanged(editTextId, editText);
    }
  };

  return (
    <View
      style={myStyles.container}
    >
      <TextInput
        style={myStyles.textInput}
        placeholder={editTextDefValue}
        placeholderTextColor="#a0aec0"
        value={editText}
        multiline={false}
        selectTextOnFocus={isDefault}
        maxLength={100} // setting limit of input
        onBlur={() => onEnterPressed()}
        onChangeText={(newText) => {
          setEditText(newText);
        }}
        onKeyPress={(e) => {
          if (e.nativeEvent.key === 'Enter') {
            onEnterPressed();
          }
        }}
        editable={!notEditable}
      />

      {(!notEditable && !isDefault) && (
        <TouchableOpacity
          onPress={onResetPressed}
        >
          <Image
            fadeDuration={0}
            style={myStyles.exitButton}
            source={img_close_x}
          />
        </TouchableOpacity>
      )}
    </View>
  );
};
export default EditTextElement;
